export const ipoConstants = {
  FETCH_IPOS_START: 'FETCH_IPOS_START',
  FETCH_IPOS_SUCCESS: 'FETCH_IPOS_SUCCESS',
  FETCH_IPOS_FAILURE: 'FETCH_IPOS_FAILURE',

  TOGGLE_DETAIL_MODAL: 'TOGGLE_DETAIL_MODAL',
  SET_CURRENT_DETAIL_MODAL: 'SET_CURRENT_DETAIL_MODAL',

  UPDATE_IPO_QUERIES: 'UPDATE_IPO_QUERIES'
};
